import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';

const PROJECT_DETAILS_QUERY = gql`
  query getProjectDetails($projectId: String!) {
    project(projectId: $projectId) {
      id
      uri
      displayText
      billingType {
        id
        uri
        displayText
      }
      timeAndExpenseEntryType {
        uri
        displayText
      }
    }
  }
`;

export const useProjectDetails = ({ projectId, skip = false }) => {
  const { data, loading } = useQuery(PROJECT_DETAILS_QUERY, {
    variables: {
      projectId
    },
    skip,
    fetchPolicy: 'cache-first'
  });

  const project = get(data, 'project', null);

  return {
    project,
    loading
  };
};

export default useProjectDetails;
